var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"icon":"","tile":"","elevation":"2"},on:{"click":_vm.onClick}},'v-btn',_vm.$attrs,false),[(_vm.flag)?_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.onIcon))]):_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.offIcon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }